import React from 'react'
import { Link } from 'react-router-dom';

function Shop({ link, item }) {
    const { logo, name, items_count, meta_data } = item;
    return (
        <div className="safe-item">
            <Link to={link} state={{ item: item }}>
                <div className="d-flex">
                    <span style={{ textDecoration: "none" }}>
                        <div className="item-img">
                            <img src={logo} />
                        </div>
                    </span>
                    <div className="item-info w-100">
                        <div className="">
                            <p>{name}</p>
                            <small>{meta_data.description}</small>
                        </div>

                        <div className={`mt-5 d-flex justify-content-end`}>
                            <span>{items_count} آگهی</span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default Shop